

export const FORM_NAMES_KEY = {
    //SPOC
    SPOC: 'SPOCComms',
    SPOC_UPDATE_EMAIL: 'GetSpocUpdateEmail',
    SPOC_UPDATE_SMS: 'GetSpocUpdateSMS',
    SPOC_UPDATE_WHATSAPP: "GetSpocUpdateWhatsApp",
    //DOCTOR
    DOCTOR: 'Doctor',
    DOCTOR_UPDATE_EMAIL: 'GetDoctorUpdateEmail',
    DOCTOR_UPDATE_SMS: 'GetDoctorUpdateSMS',
    DOCTOR_UPDATE_WHATSAPP: 'GetDoctorUpdateWhatsApp',
    //APPOINTMENT
    APPOINTMENT: 'Appointment',
    APPOINTMENT_UPDATE_EMAIL: 'GetOrderUpdateEmail',
    APPOINTMENT_UPDATE_SMS: 'GetOrderUpdateSMS',
    APPOINTMENT_UPDATE_WHATSAPP: 'GetOrderUpdateWhatsApp',


    //LABS_ACTIVE
    LABS_ACTIVE: 'selectLabsActive',
    OPD_ACTIVE: 'selectOPDActive',

    ACCESS_LEVEL: 'accessLevel',
    OFC_SPECIALITY: 'OFCspecicality',
    LAB_SPECIALITY: 'labsSpecicality',
    LABS_SERVICE: 'LABS',
    OPD_SERVICE: 'OFC',

    SELCTED_SERVICES:'selectedServices',

    COMMSELECTION:'commsSelection'

}

export const RBAC_UNAUTHORIZED_MESSAGE = "You are not Authorized for this action";

export const ACCESS_LEVEL_ARRAY = ['admin', 'editor', 'viewer'];

export const SPOC_OFC_DEPT = [
    { label: "General Physician", value: "General Physician" },
    { label: "Pediatrics", value: "Pediatrics" },
    { label: "Dentist", value: "Dentist" },
    { label: "Dermatology", value: "Dermatology" },
    { label: "Gynecology", value: "Gynecology" },
    { label: "General Surgeon", value: "General Surgeon" },
    { label: "Gastroenterology", value: "Gastroenterology" },
    { label: "Orthopaedician", value: "Orthopaedician" },
    { label: "ENT", value: "ENT" },
    { label: "Neurology", value: "Neurology" },
    { label: "Psychiatry", value: "Psychiatry" },
    { label: "Psychology", value: "Psychology" },
    { label: "Cardiologist", value: "Cardiologist" },
    { label: "Ophthalmology", value: "Ophthalmology" },
    { label: "Pulmonologist", value: "Pulmonologist" },
    { label: "Nephrology", value: "Nephrology" },
    { label: "Physiotherapist", value: "Physiotherapist" },
    { label: "Oncology", value: "Oncology" },
    { label: "Infertility", value: "Infertility" },
    { label: "Dietician", value: "Dietician" },
    { label: "Urologist", value: "Urologist" },
    { label: "Endocrinologist", value: "Endocrinologist" },
    { label: "Haematologist", value: "Haematologist" },
    { label: "Rheumatologist", value: "Rheumatologist" },
    { label: "Geriatrician", value: "Geriatrician" },
    { label: "Sexology", value: "Sexology" }
  ];


export const LABS_SERVICES = [
  { label: "Annual Health Checkup", value: "Annual Health Checkup" },
  { label: "Individual Test", value: "Individual Test" },
  { label: "Insurance", value: "Insurance" }
];


  export const Access_Level = [
    { title: "Admin", value: "admin" },
    { title: "Editor", value: "editor" },
    { title: "Viewer", value: "viewer" }
  ]

  export const INCLINIC = 'Inclinic';
  export const OFFLINE = 'Offline';
  export const SPOC_VIDEO_URL = "https://views.medibuddy.in/SPOC_Management_Provider_Central.mp4"